import React, { useRef, lazy, Suspense, useCallback } from 'react'
import Wait from '@react/react-spectrum/Wait'
import _debounce from 'lodash/debounce'
import { buildClasses } from '@demo-system/commons/utilities/styles'
import './RichTextEditor.scss'

const RichTextTool = lazy(() => import('./partials/RichTextTool'))

const RichTextEditor = ({
  disabled = false,
  onChange,
  className,
  height,
  controlledContent,
  content,
  debounce = true,
}) => {
  const quillRef = useRef()

  const onTextChange = useCallback(
    debounce
      ? _debounce(() => onChange(quillRef.current?.getSemanticHTML()), 1000)
      : () => onChange(quillRef.current?.getSemanticHTML()),
    [debounce, onChange]
  )

  return (
    <div className={buildClasses('EditorRichText', {}, className)} style={{ height }}>
      <Suspense fallback={<Wait size='L' />}>
        <RichTextTool
          defaultValue={controlledContent || content || ''}
          disabled={disabled}
          ref={quillRef}
          onTextChange={onTextChange}
        />
      </Suspense>
    </div>
  )
}

export default RichTextEditor
